import { cache } from "react";
import type { CountryType, Nullable } from "../../../@types/generic";
import reviewIconMap from "../../../app/common/skiAreaReviewIconMapping";
import { fetcher } from "../index";
import type { SkiArea } from "../types/skiArea";

export const getSkiArea = cache(
    async (
        id: string | undefined,
        country: CountryType
    ): Promise<Nullable<SkiArea>> => {
        if (!id) {
            return Promise.resolve(null);
        }

        return fetcher<SkiArea>({ path: `/ski-areas/${id}` }, { country })
            .then(({ data }) => {
                data.reviews = data.reviews.sort(
                    (a, b) =>
                        Object.keys(reviewIconMap).indexOf(a.type) -
                        Object.keys(reviewIconMap).indexOf(b.type)
                );

                return data;
            })
            .catch(() => null);
    }
);
